export enum CompanyType {
  BANK = 'BANK',
  COMPANY = 'COMPANY',
}
